export default "__VITE_ASSET__1o31_og0__"